import { FC } from 'react';
import { AutomationSettingsFactoryTypesProps } from '../../types';
import SingleSourceSelectPatternSettings from 'automation-settings/single-source-select-settings-pattern';

const TextImageScraper: FC<AutomationSettingsFactoryTypesProps> = ({
  automationSendSettings,
  automationIndex,
  selectedRecipes,
  setAutomationSendSettings,
  setCompletedFields,
  id,
  isSettingsChange,
  setIsDirty,
  automationOutputTypes,
  automationInputTypes,
}) => {
  return (
    <SingleSourceSelectPatternSettings
      id={id}
      automationIndex={automationIndex}
      selectedRecipes={selectedRecipes}
      automationSendSettings={automationSendSettings}
      setCompletedFields={setCompletedFields}
      setAutomationSendSettings={setAutomationSendSettings}
      outputKeys={['_text_image_scraper_text', '_text_image_scraper_images_zip']}
      isSettingsChange={isSettingsChange}
      setIsDirty={setIsDirty}
      automationOutputTypes={automationOutputTypes}
      automationInputTypes={automationInputTypes}
    />
  );
};

export default TextImageScraper;
